import { useMutation } from "@tanstack/react-query";
import { UPDATE_MILESTONE_REVISION_REQUEST } from "../types/RequestTypes";
import { fetcher } from "../../../utils/Axios";
import { appendRevisionToCaseSummaryCache } from "./useGetCaseSummaryQuery";

async function updateMilestoneRevision(
  reqBody: UPDATE_MILESTONE_REVISION_REQUEST
) {
  const body = { ...reqBody };
  delete body.createdAt;
  const { caseId, ...reset } = body;
  return fetcher({
    url: `case/${caseId}/milestone/revision`,
    method: "PATCH",
    data: reset,
  });
}

export default function useUpdateMilestoneRevisionMutation() {
  return useMutation({
    mutationFn: updateMilestoneRevision,
    onSuccess: (_, revision) => {
      appendRevisionToCaseSummaryCache({
        revision,
        isOptionalMilestone: false,
      });
    },
  });
}
